export function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-gray-300 mt-16">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Contact Us */}
          <div className="px-[20px] py-[0px]">
            <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-12">
              <div className="space-y-3 md:space-y-4 flex-1">
                <h4 className="text-white">联系我们</h4>
                <ul className="space-y-2 md:space-y-3 text-sm">
                  <li>
                    <span className="text-gray-400">公司：</span>
                    <span>德润慧通工程项目管理(四川)有限公司</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <span className="text-gray-400">电话：</span>
                    <span>028-62073616</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <span className="text-gray-400 flex-shrink-0">地址：</span>
                    <span>成都市高新区天府大道北段1700号6-1-510号</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <span className="text-gray-400">邮箱：</span>
                    <span>scdrht@163.com </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 md:mt-12 pt-6 md:pt-8 text-center text-xs md:text-sm">
          <p>
            Copyright © 德润慧通工程项目管理(四川)有限公司 版权所有{' '}<br /><br />
            <a 
              href="https://beian.miit.gov.cn/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors underline"
            >
              蜀ICP备2026007385号
            </a>
          </p>
          <p className="mt-2 text-gray-400">
            技术支持：<a 
              href="http://www.utscc.cn" target="_blank" rel="noopener noreferrer">四川众信联创科技有限公司</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
